// src/utils/auth.js
import { memoryStorage } from "./memoryStorage";

export const getUser = () => {
  try {
    const user = memoryStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch (err) {
    return null;
  }
};

export const isAuthenticated = () => {
  const user = getUser();
  return !!user?.role;
};
 